import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import { HostingPage, VPSPage, VDSPage } from './pages/Servers';
import FreeProducts from './pages/FreeProducts';
import FreeProductDetail from './pages/FreeProductDetail';
import TestServers from './pages/TestServers';
import Contact from './pages/Contact';
import GenericPage from './pages/GenericPage';
import Projects from './pages/Projects';
import FAQPage from './pages/FAQPage';
import Updates from './pages/Updates';
import UpdateDetail from './pages/UpdateDetail';
import { Blog, Gallery, MobileApps } from './pages/EmptyPages';
import BlogDetail from './pages/BlogDetail';
import ComingSoon from './pages/ComingSoon';
import { Login, Register } from './pages/Auth';

import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminResource from './pages/admin/AdminResource';
import AdminMedia from './pages/admin/AdminMedia';
import AdminSettings from './pages/admin/AdminSettings';

import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './context/I18nContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { UserAuthProvider } from './context/UserAuthContext';
import { CartProvider } from './context/CartContext';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import AccountLayout from './pages/account/AccountLayout';
import { AccountDashboard, AccountOrders, AccountWishlist, AccountProfile } from './pages/account/AccountPages';
import { AccountWallet, AccountDownloads, AccountBilling, AccountServices, Account2FA } from './pages/account/AccountFeatures';
import FloatingSocial from './components/FloatingSocial';
import GoogleAnalytics from './components/GoogleAnalytics';

import { API } from './api';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { 
    window.scrollTo(0, 0); 
    // Track visit
    API.post('/track-visit', { path: pathname }).catch(() => {});
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <I18nProvider>
        <UserAuthProvider>
          <CartProvider>
            <AdminAuthProvider>
              <div className="App">
                <BrowserRouter>
                  <ScrollToTop />
                  <GoogleAnalytics />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:slug" element={<ProductDetail />} />
                    <Route path="/hosting" element={<HostingPage />} />
                    <Route path="/vps" element={<VPSPage />} />
                    <Route path="/vds" element={<VDSPage />} />
                    <Route path="/free-products" element={<FreeProducts />} />
                    <Route path="/free-products/:slug" element={<FreeProductDetail />} />
                    <Route path="/test-servers" element={<TestServers />} />
                    <Route path="/test-sunuculari" element={<TestServers />} />
                    <Route path="/updates" element={<Updates />} />
                    <Route path="/updates/:slug" element={<UpdateDetail />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/mobile-apps" element={<MobileApps />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/projelerimiz" element={<Projects />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/pages/:slug" element={<GenericPage />} />
                    <Route path="/about" element={<GenericPage slug="about" />} />
                    <Route path="/privacy" element={<GenericPage slug="privacy" />} />
                    <Route path="/terms" element={<GenericPage slug="terms" />} />
                    <Route path="/kvkk" element={<GenericPage slug="kvkk" />} />
                    <Route path="/refund" element={<GenericPage slug="refund" />} />
                    <Route path="/mobile-privacy" element={<GenericPage slug="mobile-privacy" />} />

                    {/* Cart & Checkout */}
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />

                    {/* Customer account */}
                    <Route path="/account" element={<AccountLayout />}>
                      <Route index element={<AccountDashboard />} />
                      <Route path="wallet" element={<AccountWallet />} />
                      <Route path="orders" element={<AccountOrders />} />
                      <Route path="downloads" element={<AccountDownloads />} />
                      <Route path="services" element={<AccountServices />} />
                      <Route path="wishlist" element={<AccountWishlist />} />
                      <Route path="profile" element={<AccountProfile />} />
                      <Route path="billing" element={<AccountBilling />} />
                      <Route path="2fa" element={<Account2FA />} />
                    </Route>

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                      <Route index element={<AdminDashboard />} />
                      <Route path="media" element={<AdminMedia />} />
                      <Route path="settings" element={<AdminSettings />} />
                      <Route path=":collection" element={<AdminResource />} />
                    </Route>

                    <Route path="*" element={<ComingSoon eyebrow="404" title={<><span className="text-white">Sayfa </span><span className="gold-text">Bulunamadı</span></>} />} />
                  </Routes>
                </BrowserRouter>
                <FloatingSocial />
                <Toaster />
              </div>
            </AdminAuthProvider>
          </CartProvider>
        </UserAuthProvider>
      </I18nProvider>
    </HelmetProvider>
  );
}

export default App;
